module.exports = __webpack_public_path__ + "img/hr.8f6905a.svg";